import { render } from "./snackComp.vue?vue&type=template&id=803d90e6"
import script from "./snackComp.vue?vue&type=script&lang=js"
export * from "./snackComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__